import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import { selectServiceRequestDocuments, selectServiceRequestId } from 'redux/selectors/request';
import { getServiceRequestDocuments } from 'redux/actions/request';
import { StateType } from 'types';
import { selectUserType } from 'redux/selectors/auth';

const mapStateToProps = (state: StateType) => ({
  userType: selectUserType(state),
  serviceRequestId: selectServiceRequestId(state),
  requestDocuments: selectServiceRequestDocuments(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    getServiceRequestDocuments,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
